import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {otherShipmentQuotationList} from "../tableSettings";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import * as XCol from '../../../framework.core/XExportColumn';
import { QuotationArgs } from '../../../fms.report/args';
import {DocumentType} from '../../../framework.core/DocumentType';
import useReportViewer from '../../../hooks/useReportViewer';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSecTask } from '../../../fms.core/constants';
import { OtQuotationListItem } from '../../../fms.data/models/OtQuotationListItem';
import { findSecurityTask } from '../../../util';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus  } from '@fortawesome/free-solid-svg-icons';
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';

function IndicatorRenderer({ data, row }: any) {
  //const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px'}} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  //}
  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory(); const operation = 'otherShipment';

  const selectedElement = jobListContext.selectedElement as OtQuotationListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `/otherShipment/quotation/add`, NavigationType.newPage);
  }

  async function deleteQuotation() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Quotation first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OtQuotation, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/quotation/edit/${id}`;
    const viewUrl = `/otherShipment/quotation/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/otherShipment/quotation/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/quotation/edit/${id}`;
    const viewUrl = `/otherShipment/quotation/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.OTQuot);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/otherShipment/quotation/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/otherShipment/quotation/add?copyId=${id}`, NavigationType.newPage);
  }

  async function print() {
    const title = `Other Shipment Quotation ${selectedElement.quoteNo}`;
    const args = new QuotationArgs({
      docType: DocumentType.QuotationOT,
      formCaption: title,
      subject: title,

      quoteID: selectedElement.id,
      branch: appContext.user?.branch??'',
      toCompanyid: `${selectedElement.customer}`,
      tbName: 'T_GENQUOTATION',
      tbId: selectedElement.id?.toString()||'0',
    })
    viewReport(args, "", true);
  }

  return {create, deleteQuotation, edit, view, copy, print, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteQuotation, edit, view, copy } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
   const appContext = useContext(ApplicationContext);
  
  const listSec = findSecurityTask(appContext, FmsSecTask.OTQuot);

  
  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];


  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="otQuotation-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteQuotation();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        copy();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as OtQuotationListItem;

  const {deleteQuotation, edit, view, copy, print} = useSelectedOperations();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/view/${id}`);
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/quotation/add`);
  }

 const listSec = findSecurityTask(appContext,  FmsSecTask.OTQuot);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;


  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
       {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
      <UniqueLinkButton newStyle name='otQuotation-list-add-button' display="primary" link={'/otherShipment/quotation/add'} disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
      <EditIconButton2 name='otQuotation-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
      <ViewIconButton2 name='otQuotation-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
      <DeleteIconButton2 name='otQuotation-list-delete-button' disabled={!canBeDeleted} onClick={deleteQuotation} useText/>
      </div>
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='otQuotation-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        <PrintIconButton data-tooltip='Print Quotation' name='otQuotation-list-print-button' disabled={!hasSelectedRow} onClick={print} useText/>
      </div>
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext,  FmsSecTask.OTQuot);

  const {copy, create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OtQuotation}
      jobId={(jobListContext.selectedElement as OtQuotationListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class QuotationListView
 * @extends {AbstractListView}
 */
class QuotationListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {

    const apiResult = await api.getListItems (
      JobNames.OtQuotation,
      'OtQuotationListItem',
      OtQuotationListItem.calculateSearchParameters(search, OtQuotationListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

     if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
       return {data: [], totalCount: 0};
     }

  return {data: OtQuotationListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
    
  }

  
  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OtQuotation, 'OtQuotationListItem',
      OtQuotationListItem.calculateSearchParameters(search, OtQuotationListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return OtQuotationListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {

    return OtQuotationListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u1Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  otherShipmentQuotationList;
    const cols = OtQuotationListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: OtQuotationListItem) {
    return row && row.id ? `/otherShipment/quotation/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Quotation List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default QuotationListView;
